var _path, _path2, _g, _path3, _path4, _path5, _path6, _g2, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcon2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 118,
    height: 100,
    viewBox: "0 0 118 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_206_4026",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 118,
    height: 100
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M117.291 0H0V100H117.291V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_206_4026)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_206_4026",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 118,
    height: 100
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M117.291 0H0V100H117.291V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_206_4026)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.89053 75.6026V95.1185H112.41V75.6026H105.075C103.725 75.6026 102.629 74.5088 102.629 73.1618V53.6459C102.629 52.299 103.725 51.2052 105.075 51.2052H109.965C111.315 51.2052 112.41 50.1114 112.41 48.7644V19.4956C112.41 18.1487 111.315 17.0549 109.965 17.0549H105.075C103.725 17.0549 102.629 15.9611 102.629 14.6141C102.629 13.2672 101.534 12.1734 100.194 12.1734H9.78103C8.43157 12.1734 7.33578 13.2672 7.33578 14.6141V46.3237C7.33578 47.6706 8.43157 48.7644 9.78103 48.7644H16.6906L28.1762 35.0111C28.6429 34.4541 29.3328 34.1402 30.0532 34.1402H61.1008C65.1491 34.1402 68.4365 37.4215 68.4365 41.4523V73.1618C68.4365 74.5088 67.3407 75.6026 65.9913 75.6026H4.90068H4.89053ZM112.4 100H4.88037C2.19161 100 -0.0101318 97.8124 -0.0101318 95.1185V75.6026C-0.0101318 72.9188 2.18147 70.7211 4.88037 70.7211H63.5257V41.4523C63.5257 40.1053 62.4299 39.0115 61.0805 39.0115H31.1795L19.6939 52.7648C19.2272 53.3218 18.5372 53.6459 17.8168 53.6459H9.76071C5.71236 53.6459 2.42499 50.3646 2.42499 46.3237V14.6141C2.42499 10.5833 5.71236 7.302 9.76071 7.302H100.174C103.36 7.302 106.079 9.33765 107.084 12.1734H109.945C113.993 12.1734 117.281 15.4547 117.281 19.4956V48.7644C117.281 52.8053 113.993 56.0867 109.945 56.0867H107.5V70.7211H112.39C115.089 70.7211 117.281 72.9086 117.281 75.6026V95.1185C117.281 97.8023 115.089 100 112.39 100",
    fill: "#4493B1"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M107.52 31.7097H102.629V53.6562H107.52V31.7097Z",
    fill: "#4493B1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M107.52 14.624H102.629V24.387H107.52V14.624Z",
    fill: "#4493B1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6714 51.2151H9.78094V68.2902H14.6714V51.2151Z",
    fill: "#4493B1"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_206_4026",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 118,
    height: 100
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M117.291 0H0V100H117.291V0Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_206_4026)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M85.5228 34.1401C82.8239 34.1401 80.6323 36.3276 80.6323 39.0114C80.6323 41.6953 82.8239 43.8929 85.5228 43.8929C88.2217 43.8929 90.4133 41.7054 90.4133 39.0114C90.4133 36.3175 88.2217 34.1401 85.5228 34.1401ZM85.5228 48.7744C80.1352 48.7744 75.7418 44.3993 75.7418 39.0114C75.7418 33.6235 80.125 29.2585 85.5228 29.2585C90.9206 29.2585 95.3038 33.6337 95.3038 39.0114C95.3038 44.3892 90.9206 48.7744 85.5228 48.7744Z",
    fill: "#4493B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.5228 56.0966C82.8239 56.0966 80.6323 58.2842 80.6323 60.968C80.6323 63.6518 82.8239 65.8495 85.5228 65.8495C88.2217 65.8495 90.4133 63.6619 90.4133 60.968C90.4133 58.274 88.2217 56.0966 85.5228 56.0966ZM85.5228 70.731C80.1352 70.731 75.7418 66.3559 75.7418 60.968C75.7418 55.5801 80.125 51.2151 85.5228 51.2151C90.9206 51.2151 95.3038 55.5902 95.3038 60.968C95.3038 66.3457 90.9206 70.731 85.5228 70.731Z",
    fill: "#4493B1"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6714 -0.010498H9.78094V9.75251H14.6714V-0.010498Z",
    fill: "#4493B1"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M87.9681 -0.010498H83.0877V9.75251H87.9681V-0.010498Z",
    fill: "#4493B1"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon2);
export default __webpack_public_path__ + "static/media/icon_2.0c506ef6f67d3639ac8dee0d928a07d4.svg";
export { ForwardRef as ReactComponent };